<script setup>
  const { color, url } = defineProps(['color', 'url']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <div :to="url" class="card" :class="color"><slot /></div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .card {
    position: relative;
    background-color: $black-2;

    &:before {
      position: absolute;
      z-index: 2;

      content: '';
      display: block;

      width: 100%;
      height: px(6);

      top: 0;
      left: 0;

      background-color: $dark-red;
    }

    &.gold {
      &:before {
        @include gold-background;
      }
    }
  }
</style>
